import serverInterface from 'server-interface';

import externalEventCodes from 'event-system/codes/external';

import {
  applyTraits
} from 'utilities/javascript';

import {
  filterByPropertyValueBasic,
  findIndexByPropertyValue
} from 'utilities/collection';

import DataManagerTraits from '../traits';

class DataCollectionFiltersManager {

  constructor(application) {

    this.initialized = false;
    this.collection = [];
    this.loadedCollections = [];

    this.application = application;

  }

  handleCreatedEvent(payload) {

    this.tryAdd(payload.collection);

  }

  handleUpdatedEvent(payload) {

    this.tryRemove(payload.collection._id);
    this.tryAdd(payload.collection);

  }

  handleDeletedEvent(payload) {

    this.tryRemove(payload.collection._id);

  }

  registerEventHandlers() {

    this.application.eventSystem.internal.on(externalEventCodes.DATA_COLLECTION_FILTER_CREATED, this.handleCreatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.DATA_COLLECTION_FILTER_UPDATED, this.handleUpdatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.DATA_COLLECTION_FILTER_DELETED, this.handleDeletedEvent.bind(this));

  }

  getAll(collectionId) {

    return filterByPropertyValueBasic(this.collection, 'collectionId', collectionId).sort(function sorter(a, b) {
      return a.createdAt - b.createdAt;
    });

  }

  async loadAll(collectionId) {

    if (this.loadedCollections.includes(collectionId) === true) {
      return;
    }

    this.loadedCollections.push(collectionId);

    const filters = await serverInterface.startup.dataCollections.filters.getFiltersByCollectionId(collectionId);

    this.collection = [
      ...this.collection,
      ...filters
    ];

  }

  async loadAllForce(collectionId) {

    this.loadedCollections = this.loadedCollections.filter(function filter(id) {
      return id !== collectionId;
    });

    this.collection = this.collection.filter(function filter(item) {
      return item.collectionId !== collectionId;
    });

    await this.loadAll(collectionId);

  }

  async initialize() {

    this.registerEventHandlers();

    this.initialized = true;

  }

  async create(collectionId) {

    let item = await serverInterface.startup.dataCollections.filters.createEmptyFilter(collectionId);

    this.tryAdd(item);

    return item;

  }

  async update(collectionId, filterId, data) {

    let item = await serverInterface.startup.dataCollections.filters.updateFilterById(collectionId, filterId, data);

    this.tryRemove(filterId);
    this.tryAdd(data);

    return item;

  }

  async pushFilterReference(collectionId, filterId, reference) {

    const updated = await this.application.serverInterface.startup.dataCollections.filters.pushFilterReference(collectionId, filterId, reference);

    if (updated === true) {
      const index = this.getIndexById(filterId);
      this.collection[index].references.push(reference);
    }

  }

  async pullFilterReference(collectionId, filterId, reference) {

    const updated = await this.application.serverInterface.startup.dataCollections.filters.pullFilterReference(collectionId, filterId, reference);

    if (updated === true) {
      const index = this.getIndexById(filterId);
      const referenceIndex = findIndexByPropertyValue(this.collection[index].references, '_id', reference._id);
      this.collection[index].references.splice(referenceIndex, 1);
    }

  }

  async delete(collectionId, itemId) {

    await serverInterface.startup.dataCollections.filters.deleteFilter(collectionId, itemId);

    this.tryRemove(itemId);

  }

}

export default applyTraits(DataCollectionFiltersManager, [DataManagerTraits]);